module.exports = __webpack_public_path__ + "img/logo16.61def943.png";